import { render, staticRenderFns } from "./OralExpressionClose.vue?vue&type=template&id=dddd7032&scoped=true&"
import script from "./OralExpressionClose.vue?vue&type=script&lang=js&"
export * from "./OralExpressionClose.vue?vue&type=script&lang=js&"
import style0 from "./OralExpressionClose.vue?vue&type=style&index=0&id=dddd7032&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddd7032",
  null
  
)

export default component.exports